"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = require("react");

const TrustpilotContext = /*#__PURE__*/(0, _react.createContext)({});
var _default = TrustpilotContext;
exports.default = _default;